export default __webpack_public_path__ + "static/media/grafema_amcc_12.9dcbb210.jpg";